<script setup>
import {useEnv} from '@/composables/use-env.js'

//Emits and props
defineProps({
  content: {
    type: [String, Number, Object, Array],
    default: '',
  },
})

//Environment
const {isLocal, isDev, isQa} = useEnv()
</script>

<template>
  <pre
    v-if="isLocal || isDev || isQa"
    :class="$style.debug"
  ><slot>{{ content }}</slot></pre>
</template>

<style module>
.debug {
  margin: 1rem 0;
  padding: 2rem;
  background: var(--color-blue);
  color: var(--color-white);
  border-radius: var(--border-radius-m);
  max-width: calc(100vw - 2rem);
  white-space: pre-wrap !important;
  word-wrap: break-word !important;
}
</style>
